// Modal para gerar um novo pagamento.

import React from "react";
import axios from "axios";

const NovoPagamentoModal = ({
    BANK_OPTIONS,
    PAYMENT_TYPES,
    idProcess,
    token,
    formatCpf_Cnpj,
    responsePagamento,
    handleInputChange,
    setValue,
    value,
}) => {
    // Funções auxiliares de pagamento
    function tipoPagamento() {
        let tipo = document.querySelector("#tipo");

        if (tipo.value == "Acordo") {
            document.querySelector("#classN").style.display = "block"
            document.querySelector("#pagamentoAnexo").style.display = "none"
            document.querySelector("#upload2").value = ""
        } else {
            document.querySelector("#classN").style.display = "none"
            document.querySelector("#pagamentoAnexo").style.display = "block"
        }
    }

    function generatePayment() {
        if (responsePagamento.length == 0) {
            return (
                <div>
                    <label className="required" for="m-cadastrar-descricaoLbl">
                        Informe o tipo de guia
                    </label>
                    <select
                        className="form-control"
                        id="tipo"
                        name="tipo"
                        onChange={() => tipoPagamento()}
                        style={{ visibility: "visible", display: "block" }}
                    >
                        {PAYMENT_TYPES.map((type) => (
                            <option key={type} value={type}>
                                {type}
                            </option>
                        ))}
                    </select>
                    <div
                        id="classN"
                        className
                        style={{ visibility: "visible", display: "none" }}
                    >
                        <label className="required" htmlFor="m-cadastrar-nomes">
                            Nome
                        </label>
                        <input
                            className="form-control"
                            maxLength={50}
                            type="text"
                            id="nomes_novo"
                            name="nomes"
                        />
                        <label className="required" htmlFor="m-cadastrar-banco">
                            Banco
                        </label>
                        <select
                            type="text"
                            id="banco_novo"
                            className="form-control"
                            name="banco"
                        >
                            {BANK_OPTIONS.map((bank) => (
                                <option key={bank} value={bank}>
                                    {bank}
                                </option>
                            ))}
                        </select>
                        <label className="required" htmlFor="m-cadastrar-cpf">
                            CPF/CNPJ
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            id="cpf_novo"
                            onInput={formatCpf_Cnpj}
                            name="cpf"
                        />
                        <label
                            className="required"
                            htmlFor="m-cadastrar-agencia"
                        >
                            Agência
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            maxLength={4}
                            minLength={4}
                            id="agencia_novo"
                            name="agencia"
                        />
                        <label className="required" htmlFor="m-cadastrar-conta">
                            Conta
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            maxLength={11}
                            minLength={5}
                            id="conta_novo"
                            name="conta"
                        />
                        <label
                            className="required"
                            htmlFor="m-cadastrar-digito"
                        >
                            Dígito
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            maxLength={1}
                            minLength={1}
                            id="digito_novo"
                            name="digito"
                        />
                        <label
                            className="required"
                            htmlFor="m-cadastrar-entidadeLbl"
                        >
                            Informe o Número de Parcelas do Pagamento
                        </label>
                        <input
                            className="form-control"
                            type="number"
                            defaultValue={1}
                            min={1}
                            id="numeroParcelas_novo"
                            name="numeroParcelas"
                        />
                    </div>
                </div>
            );
        } else {
            if (responsePagamento[0].tipo == "Acordo") {
                return (
                    <div>
                        <label
                            className="required"
                            for="m-cadastrar-descricaoLbl"
                        >
                            Informe o tipo de guia
                        </label>
                        <input
                            className="text"
                            type="text"
                            name="tipo"
                            style={{ visibility: "visible", display: "none" }}
                            value="Acordo"
                        />
                        <select
                            class="form-control"
                            id="tipo"
                            name="tipo"
                            onClick={() => tipoPagamento()}
                            style={{ visibility: "visible", display: "block" }}
                            disabled
                        >
                            <option selected>Acordo</option>
                        </select>
                        <div
                            id="classN"
                            className
                            style={{ visibility: "visible", display: "block" }}
                        >
                            <label
                                className="required"
                                htmlFor="m-cadastrar-nomes"
                            >
                                Nome
                            </label>
                            <input
                                className="form-control"
                                maxLength={50}
                                type="text"
                                id="nomes_novo"
                                name="nomes"
                            />
                            <label
                                className="required"
                                htmlFor="m-cadastrar-banco"
                            >
                                Banco
                            </label>
                            <select
                                type="text"
                                id="banco_novo"
                                className="form-control"
                                name="banco"
                            >
                                {BANK_OPTIONS.map((bank) => (
                                    <option key={bank} value={bank}>
                                        {bank}
                                    </option>
                                ))}
                            </select>
                            <label
                                className="required"
                                htmlFor="m-cadastrar-cpf"
                            >
                                CPF/CNPJ
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                id="cpf_novo"
                                onInput={formatCpf_Cnpj}
                                name="cpf"
                            />
                            <label
                                className="required"
                                htmlFor="m-cadastrar-agencia"
                            >
                                Agência
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                maxLength={4}
                                minLength={4}
                                id="agencia_novo"
                                name="agencia"
                            />
                            <label
                                className="required"
                                htmlFor="m-cadastrar-conta"
                            >
                                Conta
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                maxLength={11}
                                minLength={5}
                                id="conta_novo"
                                name="conta"
                            />
                            <label
                                className="required"
                                htmlFor="m-cadastrar-digito"
                            >
                                Dígito
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                maxLength={1}
                                minLength={1}
                                id="digito_novo"
                                name="digito"
                            />
                            <label
                                className="required"
                                htmlFor="m-cadastrar-entidadeLbl"
                            >
                                Informe o Número de Parcelas do Pagamento
                            </label>
                            <input
                                className="form-control"
                                type="number"
                                defaultValue={1}
                                min={1}
                                id="numeroParcelas_novo"
                                name="numeroParcelas"
                            />
                        </div>
                    </div>
                );
            } else {
                return (
                    <div>
                        <label for="m-cadastrar-descricaoLbl">
                            Informe o tipo de guia
                        </label>
                        <select
                            class="form-control"
                            id="tipo"
                            name="tipo"
                            onClick={() => tipoPagamento()}
                            style={{ visibility: "visible", display: "block" }}
                        >
                            {PAYMENT_TYPES.map((type) => (
                                <option key={type} value={type}>
                                    {type}
                                </option>
                            ))}
                        </select>
                        <div
                            id="classN"
                            className
                            style={{ visibility: "visible", display: "none" }}
                        >
                            <label
                                className="required"
                                htmlFor="m-cadastrar-nomes"
                            >
                                Nome
                            </label>
                            <input
                                className="form-control"
                                maxLength={50}
                                type="text"
                                id="nomes_novo"
                                name="nomes"
                            />
                            <label
                                className="required"
                                htmlFor="m-cadastrar-banco"
                            >
                                Banco
                            </label>
                            <select
                                type="text"
                                id="banco_novo"
                                className="form-control"
                                name="banco"
                            >
                                {BANK_OPTIONS.map((bank) => (
                                    <option key={bank} value={bank}>
                                        {bank}
                                    </option>
                                ))}
                            </select>
                            <label
                                className="required"
                                htmlFor="m-cadastrar-cpf"
                            >
                                CPF/CNPJ
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                id="cpf_novo"
                                onInput={formatCpf_Cnpj}
                                name="cpf"
                            />
                            <label
                                className="required"
                                htmlFor="m-cadastrar-agencia"
                            >
                                Agência
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                maxLength={4}
                                minLength={4}
                                id="agencia_novo"
                                name="agencia"
                            />
                            <label
                                className="required"
                                htmlFor="m-cadastrar-conta"
                            >
                                Conta
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                maxLength={11}
                                minLength={5}
                                id="conta_novo"
                                name="conta"
                            />
                            <label
                                className="required"
                                htmlFor="m-cadastrar-digito"
                            >
                                Dígito
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                maxLength={1}
                                minLength={1}
                                id="digito_novo"
                                name="digito"
                            />
                            <label
                                className="required"
                                htmlFor="m-cadastrar-entidadeLbl"
                            >
                                Informe o Número de Parcelas do Pagamento
                            </label>
                            <input
                                className="form-control"
                                type="number"
                                defaultValue={1}
                                min={1}
                                id="numeroParcelas_novo"
                                name="numeroParcelas"
                            />
                        </div>
                    </div>
                );
            }
        }
    }

    function novoPagamento() {
        const formData = new FormData();
        const tipo = document.querySelector("#tipo").value;
        console.log("------------------" + tipo);
        if (tipo == "Acordo") {
            const nomes = document.querySelector("#nomes_novo").value;
            const banco = document.querySelector("#banco_novo").value;
            const cpf = document.querySelector("#cpf_novo").value;
            const agencia = document.querySelector("#agencia_novo").value;
            const conta = document.querySelector("#conta_novo").value;
            const digito = document.querySelector("#digito_novo").value;
            const data_pagamento = document.querySelector(
                "#data_pagamento_novo"
            ).value;
            const valor = document.querySelector("#valor_novo").value;
            const numeroParcelas = document.querySelector(
                "#numeroParcelas_novo"
            ).value;
            const descricao = document.querySelector("#descricao_novo").value;

            formData.append("token", token);
            formData.append("nomes", nomes);
            formData.append("tipo", tipo);
            formData.append("banco", banco);
            formData.append("cpf", cpf);
            formData.append("agencia", agencia);
            formData.append("conta", conta);
            formData.append("digito", digito);
            formData.append("data_pagamento", data_pagamento);
            formData.append("valor", valor);
            formData.append("numeroParcelas", numeroParcelas);
            formData.append("descricao", descricao);
            axios
                .post(`/api/new/payment/${idProcess}`, formData, {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((resp) => {
                    if (resp.data.erros.length === 0) {
                        window.location = resp.data.url;
                    } else {
                        for (let i = 0; i < resp.data.erros.length; i++) {
                            let elemento = document.querySelector(
                                `#${resp.data.erros[i].elemento}`
                            );
                            console.log(resp.data.erros[i].elemento);
                            elemento.style.backgroundColor = "#FFC0CB";
                        }
                    }
                });
        } else {
            const data_pagamento = document.querySelector(
                "#data_pagamento_novo"
            ).value;
            const valor = document.querySelector("#valor_novo").value;
            const numeroParcelas = document.querySelector(
                "#numeroParcelas_novo"
            ).value;
            const descricao = document.querySelector("#descricao_novo").value;

            const upload = document.querySelector("#upload2");
            if (upload.files.length > 0) {
                formData.append("upload", upload.files[0]);
            }
            formData.append("tipo", tipo);
            formData.append("token", token);
            formData.append("data_pagamento", data_pagamento);
            formData.append("valor", valor);
            formData.append("numeroParcelas", numeroParcelas);
            formData.append("descricao", descricao);

            axios
                .post(`/api/new/payment/${idProcess}`, formData, {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((resp) => {
                    if (resp.data.erros.length === 0) {
                        window.location = resp.data.url;
                    } else {
                        for (let i = 0; i < resp.data.erros.length; i++) {
                            let elemento = document.querySelector(
                                `#${resp.data.erros[i].elemento}`
                            );
                            elemento.style.backgroundColor = "#FFC0CB";
                        }
                    }
                });
        }
    }

    // Funções auxiliares de arquivos
    const removeAttachmentPayment = (event) => {
        const inputFile = document.querySelector("#upload2");
        const attachments = document.querySelector("#arquivosAdd"); // obtém todos os elementos .row dentro do divUp1
        if (inputFile) {
            inputFile.value = "";
            attachments.remove();
        }
    };

    const selectedAttachment = (event) => {
        let file = event.target.files;
        const verifyFile = document.querySelector("#arquivosAdd");
        if (verifyFile) {
            verifyFile.remove();
        }
        const novos = document.querySelector("#novoAnexo");
        const rowDiv = document.createElement("div");
        rowDiv.className = "row";
        rowDiv.id = "arquivosAdd";

        const col7Div = document.createElement("div");
        col7Div.className = "col-12";

        const label = document.createElement("label");
        label.textContent = `${file[0].name}`;
        const spanUpload = document.createElement("span");
        spanUpload.className = "hidden-xs";
        const iconUp = document.createElement("i");
        iconUp.className =
            "fa fa-minus-circle ml-3 btn-remove-anexo text-danger";
        iconUp.style.fontSize = "1.25em";
        iconUp.style.position = "relative";
        iconUp.style.top = ".15em";
        iconUp.onclick = removeAttachmentPayment;
        spanUpload.appendChild(iconUp);
        col7Div.appendChild(label);
        col7Div.appendChild(spanUpload);
        rowDiv.appendChild(col7Div);

        //divUpload.insertBefore(rowDiv, newAtt)
        novos.appendChild(rowDiv);
    };

    function clickUploadNovoPagamento() {
        const inputFile = document.getElementById("upload2");
        inputFile.click();
    }

    function controlAttachment() {
        return (
            <div
                className="row"
                id="pagamentoAnexo"
                style={{ visibility: "visible", display: "block" }}
            >
                <div className="col-10">
                    <label for="m-cadastrar-descricaoLbl">Novos anexos</label>
                </div>
                <input
                    name="upload"
                    id="upload2"
                    type="file"
                    onChange={selectedAttachment}
                ></input>
                <div className="col-2">
                    <button
                        type="button"
                        className="btn btn-success"
                        title="Upload"
                        onClick={() => clickUploadNovoPagamento()}
                    >
                        <i className="fas fa-file-upload"></i>
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div
            className="modal fade"
            id="exampleModal"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div
                className="modal-dialog"
                role="document"
                style={{ marginTop: "70px" }}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            Gerar Novo Pagamento
                        </h5>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {generatePayment()}

                        <label
                            className="required"
                            htmlFor="m-cadastrar-descricaoLbl"
                        >
                            Informe a data da primeira parcela
                        </label>
                        <div
                            className="input-group date"
                            id="reservationdate"
                            data-target-input="nearest"
                        >
                            <input
                                type="date"
                                id="data_pagamento_novo"
                                className="form-control datetimepicker-input"
                                data-target="#reservationdate"
                                name="data"
                            />
                        </div>
                        <label
                            className="required"
                            htmlFor="m-cadastrar-descricaoLbl"
                        >
                            Informe o valor da parcela do pagamento R$
                        </label>
                        <input
                            type="text"
                            id="valor_novo"
                            value={value}
                            className="form-control"
                            onChange={(event) =>
                                handleInputChange(event, setValue)
                            }
                            name="valor"
                        />
                        <label htmlFor="m-cadastrar-descricaoLbl">
                            Informe a descricao
                        </label>
                        <textarea
                            className="form-control"
                            id="descricao_novo"
                            rows="3"
                            name="descricao"
                        ></textarea>
                        {controlAttachment()}
                        <div className="col-12" id="novoAnexo"></div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Fechar
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={novoPagamento}
                        >
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NovoPagamentoModal;
